// The property list filters are round-tripped through the url query string so
// that back / forward restore the same view, matching the property history page.

export type PropertyListFilters = {
  season?: string;
  city?: string;
  // The jobs endpoint reads `1` as "include inactive"; the url carries "true".
  include_inactive?: 1;
};

export function buildPropertyListQueryParams(
  filters: PropertyListFilters,
  searchTerm: string | null,
): string {
  const queryParams = new URLSearchParams();
  if (filters.season) {
    queryParams.set("season", filters.season);
  }
  if (filters.city) {
    queryParams.set("city", filters.city);
  }
  if (filters.include_inactive) {
    queryParams.set("include_inactive", "true");
  }
  if (searchTerm) {
    queryParams.set("searchTerm", searchTerm);
  }
  return queryParams.toString();
}

export function getPropertyListFiltersFromQuery(
  queryParams: URLSearchParams,
): PropertyListFilters {
  const filters: PropertyListFilters = {};
  const season = queryParams.get("season");
  if (season) {
    filters.season = season;
  }
  const city = queryParams.get("city");
  if (city) {
    filters.city = city;
  }
  if (queryParams.get("include_inactive") === "true") {
    filters.include_inactive = 1;
  }
  return filters;
}

export function getPropertyListSearchTerm(
  queryParams: URLSearchParams,
): string | null {
  return queryParams.has("searchTerm") ? queryParams.get("searchTerm") : null;
}
